import get from 'lodash/get';
import { RegisterOptions } from 'react-hook-form';
import i18next from 'i18next';
import isNumber from 'lodash/isNumber';
import { FieldErrors } from 'react-hook-form/dist/types/errors';
import { Validate } from 'react-hook-form/dist/types/validator';

import { FormPropsType } from 'src/components/UI/types';
import { EMAIL_PATTERN } from 'src/config';
import { numberOrDefaultNumber } from 'src/utils/numbers';

export const getInputMaxLength = (max?: number): number => numberOrDefaultNumber(max, 300);

type Props = {
  label: string;
  type: 'email' | 'text' | 'password' | 'textarea';

  validate?: Validate<unknown>;
  maxLength?: number;
  minLength?: number;
  pattern?: RegExp;
};

/**
 * input validation and rules for rhf
 *
 * everything can be made with validate()
 */
export const getInputRegisterOptions = ({
  maxLength,
  minLength,
  type,
  label,
  pattern,
  validate,
}: Props): RegisterOptions => {
  const localRegisterOptions: RegisterOptions = {
    maxLength: {
      value: getInputMaxLength(maxLength),
      message: i18next.t('common.validation.tooLong', { label }),
    },
    validate,
    pattern,
    setValueAs: (v) => (v ? v.trim() : null), // it should be null or '' ?
  };

  if (isNumber(minLength)) {
    localRegisterOptions.minLength = {
      value: minLength,
      message: i18next.t('common.validation.minLength', { label, length: minLength }),
    };
  }
  if (type === 'email') {
    localRegisterOptions.pattern = {
      value: EMAIL_PATTERN,
      message: i18next.t('common.validation.emailInvalid', {
        label,
      }),
    };
  }

  return localRegisterOptions;
};

/** calc a correct position of cursor in case of double space in a string */
export const calcInputSelection = (selectionStart: number, value: string): number =>
  value[selectionStart - 1] === ' ' && value[selectionStart - 2] === ' ' ? selectionStart - 1 : selectionStart;

/** return form error if it exists */
export const getInputError = (
  errors: FormPropsType['formState']['errors'],
  name: string,
  validationName?: string
): FieldErrors | false => get(errors, name, false) || (!!validationName && get(errors, validationName, false));
